<template>
  <div :class='b([type])' v-if='totalnum > 1'>
    <div v-if='type === "number"' :class="b('number')">
      {{ currentnum }} / {{totalnum}}
    </div>
    <div
      v-else
      :class="b('dot', {vertical})"
    >
      <i
        v-for="index in totalnum"
        :key="index"
        :class="b('item-dot', { active: index - 1 === activeIndicator })"
      />
    </div>
  </div>
</template>

<script>
import create from '../utils/create'
export default create({
  name: 'indicator',

  props: {
    currentnum: Number,
    totalnum: Number,
    type: {
      type: String,
      default: 'number'
    },
    vertical: Boolean
  },

  methods: {
    activeIndicator() {
      return (this.currentnum + this.totalnum) % this.totalnum;
    },
  }
})
</script>


// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/indicator/index.vue